// .pen: XKJge/QG2TP (Selfie · Ritual · Ativos · default|primeira)
import {
  categoryMeta,
  resolveAccountNativeCurrency,
} from '../../accounts/assetCategories';
import {
  computeAccountBalanceEur,
  computeEntryDelta,
  formatDecimalForInput,
} from '../../../lib/selfieDisplayUtils';
import pt from '../../../locales/pt';
import { SelfieBalanceRow } from './SelfieBalanceRow';

// .pen: "Selfie · Ritual · Ativos · default|primeira" › copy + lista
// title/subtitle: override para o modo edição (.pen: nU8QY "Corrigir saldos de {month}")
export function SelfieAssetsStep({
  accounts = [],
  accountEntries = {},
  previousAccountEntries = {},
  onAccountEntriesChange,
  isFirstSelfie = false,
  title,
  subtitle,
}) {
  const copy = pt.snapshots.ritual.assets;

  const updateAccount = (id, patch) => {
    onAccountEntriesChange?.({
      ...accountEntries,
      [id]: { ...accountEntries[id], ...patch, source: patch.source || 'manual' },
    });
  };

  const resetAccount = (account) => {
    const previous = previousAccountEntries[account.id];
    if (!previous) return;
    const isCrypto = account.category === 'crypto';
    updateAccount(account.id, {
      balance_native: formatDecimalForInput(previous.balance_native, {
        maxDecimals: isCrypto ? 8 : 2,
      }),
      price_per_unit:
        previous.price_per_unit !== undefined && previous.price_per_unit !== null
          ? formatDecimalForInput(previous.price_per_unit)
          : '',
      source: 'unchanged',
    });
  };

  return (
    <div className="flex flex-col gap-space-5">
      <div className="flex flex-col gap-space-2">
        <h1 className="font-display text-type-title-page font-semibold leading-[1.25] tracking-tight text-foreground">
          {title || copy.title}
        </h1>
        <p className="text-type-body leading-[1.55] text-muted-foreground">
          {subtitle || (isFirstSelfie ? copy.subtitleFirst : copy.subtitle)}
        </p>
      </div>

      <div className="flex flex-col gap-space-2-5">
        {accounts.map((account) => {
          const meta = categoryMeta(account.category);
          const Icon = meta.icon;
          const previous = previousAccountEntries[account.id];
          const entry = accountEntries[account.id] || {};
          const beforeNative = previous?.balance_native;
          const delta = computeEntryDelta(entry.balance_native, beforeNative);
          const beforeEur =
            beforeNative != null
              ? computeAccountBalanceEur(account, {
                  balance_native: String(beforeNative),
                  price_per_unit:
                    previous?.price_per_unit != null
                      ? String(previous.price_per_unit)
                      : '',
                })
              : null;

          return (
            <SelfieBalanceRow
              key={account.id}
              icon={Icon}
              tone="sage"
              name={account.name}
              beforeAmount={beforeEur}
              value={entry.balance_native ?? ''}
              onChange={(event) =>
                updateAccount(account.id, {
                  balance_native: event.target.value,
                  source: 'manual',
                })
              }
              onReset={beforeNative != null ? () => resetAccount(account) : undefined}
              delta={beforeNative != null ? delta : null}
              favorable={delta === null || delta >= 0}
              currencyLabel={resolveAccountNativeCurrency(account)}
              isCrypto={account.category === 'crypto'}
              pricePerUnit={entry.price_per_unit ?? ''}
              onPriceChange={(event) =>
                updateAccount(account.id, {
                  price_per_unit: event.target.value,
                  source: 'manual',
                })
              }
              ariaLabel={`${account.name} saldo`}
            />
          );
        })}
      </div>
    </div>
  );
}

export default SelfieAssetsStep;
